import {
  getAllTransitionsForEveryProcess,
  getProcess,
  INQUIRY_PROCESS_NAME,
  resolveLatestProcessName,
} from '../transactions/transaction';
import { transitions as bookingTransitions } from '../transactions/transactionProcessBooking';
import { transitions as inquiryProcessTransitions } from '../transactions/transactionProcessInquiry';
import { transitions as purchaseTransitions } from '../transactions/transactionProcessPurchase';

const EXPLICIT_INQUIRY_TRANSITIONS = [
  inquiryProcessTransitions.INQUIRE_WITHOUT_PAYMENT,
  inquiryProcessTransitions.EXPIRE_PAYMENT_INTENT,
  inquiryProcessTransitions.CAPTURE_PAYMENT_INTENT,
  bookingTransitions.INQUIRE,
  purchaseTransitions.INQUIRE,
  'transition/inquiry',
];

const INQUIRY_TRANSITION_PREFIXES = ['transition/inquir'];
const NORMALIZED_INQUIRY_TRANSITIONS = new Set(
  EXPLICIT_INQUIRY_TRANSITIONS.filter(Boolean).map(transition => transition.toLowerCase())
);

const dedupeTransitions = transitions => Array.from(new Set((transitions || []).filter(Boolean)));

const normalizeTransition = transition =>
  typeof transition === 'string' ? transition.trim().toLowerCase() : null;

export const isInquiryTransition = transition => {
  const normalized = normalizeTransition(transition);
  if (!normalized) {
    return false;
  }

  if (NORMALIZED_INQUIRY_TRANSITIONS.has(normalized)) {
    return true;
  }

  return INQUIRY_TRANSITION_PREFIXES.some(prefix => normalized.startsWith(prefix));
};

const getKnownProcessInquiryState = transaction => {
  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  if (!processName) {
    return null;
  }

  if (processName === INQUIRY_PROCESS_NAME) {
    return true;
  }

  try {
    const process = getProcess(processName);
    if (!process?.states?.INQUIRY) {
      return false;
    }

    return process.getState(transaction) === process.states.INQUIRY;
  } catch {
    return null;
  }
};

export const isInquiryTransaction = transaction => {
  if (!transaction) {
    return false;
  }

  const knownProcessInquiryState = getKnownProcessInquiryState(transaction);
  if (typeof knownProcessInquiryState === 'boolean') {
    return knownProcessInquiryState;
  }

  const lastTransition = transaction?.attributes?.lastTransition;
  if (lastTransition) {
    return isInquiryTransition(lastTransition);
  }

  const transitions = transaction?.attributes?.transitions || [];
  return transitions.some(entry => isInquiryTransition(entry?.transition));
};

const INQUIRY_QUERY_TRANSITIONS = [
  bookingTransitions.INQUIRE,
  purchaseTransitions.INQUIRE,
  'transition/inquiry',
];

export const getInquiryTransitionsForQuery = () => dedupeTransitions(INQUIRY_QUERY_TRANSITIONS);

export const getNonInquiryTransitionsForQuery = () =>
  dedupeTransitions(getAllTransitionsForEveryProcess()).filter(
    transition => !isInquiryTransition(transition)
  );
